import { RsvpFilterEnum } from "@clockwise/schema";
import React from "react";
import { useUpdateEventSearchFilters } from "../../../../hooks/event-search-filters/useUpdateEventSearchFilters";
import { BaseChip } from "./BaseChip";

export const RsvpFilters = ({
  rsvpFilters,
  eventSearchBlockId,
  conversationId,
  disabled = false,
}: {
  rsvpFilters: RsvpFilterEnum[];
  eventSearchBlockId: string;
  conversationId: string;
  disabled?: boolean;
}) => {
  const { updateRsvpFilters } = useUpdateEventSearchFilters();

  const onDelete = () => {
    void updateRsvpFilters(eventSearchBlockId, conversationId, []);
  };

  const rsvpFilterString = rsvpFilters
    .map((rsvp) => {
      if (rsvp === RsvpFilterEnum.NeedsAction) {
        return "Needs Action";
      }
      return rsvp;
    })
    .join(", ");

  return (
    <BaseChip onDelete={onDelete} disabled={disabled}>
      {rsvpFilterString}
    </BaseChip>
  );
};
